import React, { useState } from 'react';
import TeamsFilter from './Filters/TeamsFilter';
import TeamsTable from './Tables/TeamsTable';
import { useTeamFilterOptions } from './FilterOptions/TeamFilterOptions';

function Teams() {
  const [orderBy, setOrderBy] = useState('goals');
  const [season, setSeason] = useState(window.currentSeason);
  const [teamFilterOptions] = useTeamFilterOptions();
  const tableName = teamFilterOptions?.find(
    (option) => option.key === orderBy
  )?.name;
  const [mobileFilters, setMobileFilters] = useState(false);
  return (
    <div className="row tabs-content">
      <div className="col-12 tabs-column">
        <TeamsFilter
          setSeason={setSeason}
          season={season}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          mobileFilters={mobileFilters}
          setMobileFilters={setMobileFilters}
        />
        <div className="data-container__body d-lg-block">
          <div className="bg-primary">
            <p className="h4 mb-0" style={{ padding: '15px 15px 11px 15px' }}>
              {tableName} {season}
            </p>
          </div>
          <div className="stats-table stats-table--no-bg">
            <div
              className="stats-table__row d-none d-md-flex"
              style={{ minHeight: '54px' }}
            >
              <div className="col-1 col-md-1 heading-stats-name text-center">
                Ranking
              </div>
              <div className="col-7 col-md-6 heading-stats-name">Lag</div>
              <div className="col-auto col-md-2 d-none d-md-block heading-stats-name text-center">
                Antal matcher
              </div>
              <div className="col-3 col-md-3 heading-stats-name text-center">
                {tableName}
              </div>
            </div>
            <TeamsTable season={season} orderBy={orderBy} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Teams;
